import { render, staticRenderFns } from "./VCosts.vue?vue&type=template&id=7b49fe11&"
import script from "./VCosts.vue?vue&type=script&lang=js&"
export * from "./VCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports